module.exports = __webpack_public_path__ + "img/cart-buy.2ab41943.png";